import React from 'react';
import type { FunctionComponent } from 'react';
import { useAppDispatch } from '../../../store/store';
import { setFeatureToShow } from '../../../store/paymentTokenSlice';
import { setCreditLimitAccount } from '../../../store/creditLimitIncreaseSlice';
import { setImagePath, detectDeviceType } from '../../../utils/helpers';
import {
  captureAnalyticsDataAttributes,
  capturePageLoadAnalytics,
} from '../../../utils/analytics/analyticsDispatchers';
import { CREDIT_INCREASE_REQUEST } from '../../../utils/analytics/analyticsEvents';
import { FEATURES_TO_DISPLAY } from '../../../utils/constants/genericConstants';
import '../../creditLimitIncrease/creditLimitIncrease.css';

interface CreditIncreaseLinkProps {
  accountId: string;
  displayName: string;
  creditIncreaseButtonText: string;
}

const CreditIncreaseLink: FunctionComponent<CreditIncreaseLinkProps> = ({
  accountId,
  displayName,
  creditIncreaseButtonText,
}) => {
  const dispatch = useAppDispatch();
  const handleCreditIncreaseClick = (event: any) => {
    dispatch(
      setCreditLimitAccount({
        selectedAccountId: accountId,
        isCliModalOpen: true,
      }),
    );
    dispatch(setFeatureToShow(FEATURES_TO_DISPLAY.CREDIT_LIMIT_INCREASE));
    capturePageLoadAnalytics(CREDIT_INCREASE_REQUEST);
    captureAnalyticsDataAttributes(event);
  };

  return (
    <button
      id="syfWalletContainer"
      className="card-link-btn"
      onClick={handleCreditIncreaseClick}
      data-type={detectDeviceType}
      data-reason={`creditIncrease:${displayName}`}
      data-object="button"
      data-testid="credit-increase-button-click"
    >
      <img
        src={setImagePath('credit-increase')}
        alt="Credit Limit increase"
        className="credit-increase-btn-icon"
      />
      <span className="link-text-block">{creditIncreaseButtonText}</span>
    </button>
  );
};

export default CreditIncreaseLink;
